(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsen-shared/assets/javascripts/coupon-navigation.js') >= 0) return;  svs.modules.push('/components/sport/tipsen-shared/assets/javascripts/coupon-navigation.js');
"use strict";


const openCoupon = (history, relativeUrl) => {
  history.push(relativeUrl, {
    couponPushedFromClient: true
  });
};
const closeCoupon = history => {
  var _history$location$sta;
  if (((_history$location$sta = history.location.state) === null || _history$location$sta === void 0 ? void 0 : _history$location$sta.couponPushedFromClient) === true) {
    history.goBack();
  } else {
    history.push('/');
  }
};
setGlobal('svs.components.sport.tipsenShared.couponNavigation', {
  openCoupon,
  closeCoupon
});

 })(window);